import { render, staticRenderFns } from "./build.vue?vue&type=template&id=f9d03ad8&scoped=true"
import script from "./build.vue?vue&type=script&lang=js"
export * from "./build.vue?vue&type=script&lang=js"
import style0 from "./build.vue?vue&type=style&index=0&id=f9d03ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d03ad8",
  null
  
)

export default component.exports